$.fn.MaskedTitle = function() {
  let self = this

  self.measure = function () {
    self.css('--mask-width', self.find('.col').width() + 'px');
    self.css('--mask-height', self.find('.grid').innerHeight() + 'px');
  }

  return function() {
    $(window).on('resize orientationchange', self.measure)
    $(window).on('load', function() {
      self.measure()
      self.addClass('--mask-ready');
    })
    return self
  }()
}
